/**
 * Normalize hint/instruction markdown before render.
 *
 * CommonMark treats a single newline as a space inside one paragraph, so patterns like
 * `**What should I enter?**\nAnswer…` or `# Title\nBody` render inline. This inserts
 * block breaks so headings and bold line titles start on their own line.
 */
export function normalizeHintMarkdown(content: string): string {
  let text = content.replace(/\r\n/g, '\n');

  // Detach ATX headings glued to prior text on the same line.
  text = text.replace(/([^\n])(\s*)(#{1,6}\s+\S)/g, '$1\n\n$3');

  // Blank line after ATX heading lines so body text is a separate paragraph.
  text = text.replace(/^(#{1,6}\s+.+)\n(?!\n)/gm, '$1\n\n');

  // Bold line titles (N-400 client hints) — paragraph break after the title line.
  text = text.replace(/\*\*([^*\n]+?)\*\*\n(?!\n)/g, '**$1**\n\n');

  // Bold title following prior content with only a single newline.
  text = text.replace(/([^\n])\n(\*\*[^*\n]+?\*\*)/g, '$1\n\n$2');

  return text;
}
